import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

// Componentes
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import ServicePage from "./components/ServicesPage";

/* ============================================================
   🔝 1) Forzar scroll al inicio si NO hay hash
============================================================ */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
}

/* ============================================================
   🔗 2) Scroll automático a #services, #contact, etc.
============================================================ */
function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 200);
      }
    }
  }, [pathname, hash]);

  return null;
}

/* ============================================================
   🏠 3) Contenido de la página principal
============================================================ */
const HomePageContent = () => (
  <main className="pt-20 lg:pt-24">
    <Hero />
    <About />
    <Services />
    <Gallery />
    <Contact />
  </main>
);

/* ============================================================
   📄 4) Rutas + control de Header y Footer
============================================================ */
const AppContent = () => {
  const location = useLocation();

  // Ocultar Header y Footer en páginas individuales de servicio
  const hideHeader =
    location.pathname.startsWith("/servicios/") &&
    location.pathname !== "/servicios";

  const hideFooter =
    location.pathname.startsWith("/servicios/") &&
    location.pathname !== "/servicios";

  return (
    <>
      {!hideHeader && <Header />}

      <Routes>
        <Route path="/" element={<HomePageContent />} />
        <Route path="/servicios" element={<Services />} />
        <Route path="/servicios/:slug" element={<ServicePage />} />

        {/* 404 */}
        <Route
          path="*"
          element={
            <div className="text-center pt-40 min-h-[60vh]">
              <h1 className="text-5xl text-red-600 font-bold">404</h1>
              <p className="text-xl mt-4">Página no encontrada.</p>
            </div>
          }
        />
      </Routes>

      {!hideFooter && <Footer />}
    </>
  );
};

/* ============================================================
   🚀 5) App principal
============================================================ */
const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <ScrollToHash />

    <motion.div
      className="min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <AppContent />
    </motion.div>
  </BrowserRouter>
);

export default App;




